import PhotosResults from "./PhotosResults.page";
import PhotosResultsMobile from "./mobile/PhotosResultsMobile";
import { useEffect, useState } from "react";
import { filterOrders } from "@/lib/services/orders";
import type { OrderItem } from "@/types/types.d";
import { useLoader } from "@/store/useLoader";
import { useDevice } from "@/store/useDevice";
import { appToast } from "@/lib/toast";
import { literals } from "@/constants/literals";
import { DEFAULT_LIMIT } from "@/constants/constants";

const LayoutPhotosResults = () => {
  const { isMobile } = useDevice();
  const { upLoader, downLoader } = useLoader();
  const [filters, setFilters] = useState<any>({});
  const [data, setData] = useState<OrderItem[]>([]);
  const [page, setPage] = useState(0); // backend page (0-based)
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const [lastPage, setLastPage] = useState(0); // total pages from backend

  const handleFiltersChange = (newFilters: any) => {
    setFilters(newFilters);
    setPage(0);
    fetchResults(newFilters, 0, limit);
  };

  const fetchResults = async (
    activeFilters = filters,
    pageToLoad = page,
    limitPage: string,
  ) => {
    upLoader();
    try {
      const response = await filterOrders({
        ...activeFilters,
        page: pageToLoad,
        size: Number(limitPage),
        orderBy: "createdAt",
        order: "desc",
      });

      setData(response.content);
      setLastPage(response.totalPages);
    } catch {
      appToast.error(literals.aProblem, literals.getInfoError);
    } finally {
      downLoader();
    }
  };

  const changePage = (newPage: number) => {
    setPage(newPage);
    fetchResults(filters, newPage, limit);
  };

  const refetch = async () => {
    await fetchResults(filters, page, limit);
  };

  const handleOnReset = () => {
    setData([]);
  };

  const handleOnChangeLimit = (newLimit: string) => {
    setLimit(newLimit);
    fetchResults(filters, page, newLimit);
  };

  useEffect(() => {
    if (isMobile) {
      if (data.length > 0) {
        handleOnChangeLimit(DEFAULT_LIMIT);
      } else {
        setLimit(DEFAULT_LIMIT);
      }
    }
  }, [isMobile]);

  if (isMobile) {
    return (
      <PhotosResultsMobile
        filters={filters}
        handleFiltersChange={handleFiltersChange}
        data={data}
        cleanData={handleOnReset}
        pagination={{
          lastPage: lastPage,
          page,
          changePage,
        }}
      />
    );
  }

  return (
    <PhotosResults
      filters={filters}
      handleFiltersChange={handleFiltersChange}
      data={data}
      pagination={{
        lastPage: lastPage,
        page,
        changePage,
        limit,
        setLimit: handleOnChangeLimit,
      }}
      refetch={refetch}
    />
  );
};

export default LayoutPhotosResults;
